import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { IStore, IPagedResults, IPagedResult, IFacilityInfo, IStoreGroup, IPTIFacilityModel} from '../Shared/interface';
import { map, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppInsightsService } from './app-insights.service';
import { IStorageFacilityList } from '../Shared/interface2';
import {AppService} from './app.service';
import { UserSessionService } from './usersession.service';

@Injectable({
    providedIn: 'root',
})

export class StoreService {

    private baseURL = this.appService.config.apiBaseUrl;
    store: IStore[];
    storeGroup: IStoreGroup[];

    constructor(private http: HttpClient,
                private appinsights: AppInsightsService,
                private appService: AppService,
                private userSessionService: UserSessionService) { }

    getStoresWithGenericAndRegion(): Observable<IStore[]> {
        return this.http.get<IStore[]>(
            `${this.baseURL}/store/GetStores` )
            .pipe(
                map(store => {
                    return store as IStore[];

                }),

                catchError(this.handleError)
            );
    }

    getStores(): Observable<IStore[]> {
        return this.http.get<IStore[]>(
            `${this.baseURL}/store/GetStores` )
            .pipe(
                map(stores => {
                    stores as IStore[];
                    if (stores && stores.length) {
                        stores.map(st => {
                            st.GenericStoreGroups = [];
                        });
                        this.userSessionService.allStoresListFromGetStores = stores;
                        return stores;
                    } else {
                        return stores;
                    }

                }),

                catchError(this.handleError)
            );
    }

    getStoreGroup(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/StoreGroup/GetStoreGroups` )
            .pipe(
                map(storeGroup => {
                    return storeGroup;

                }),
                catchError(this.handleError)
            );
    }
    getUsers(): Observable<any> {
        return this.http.get<any>(
            `${this.baseURL}/User/GetUsersActiveOrInactive` )
            .pipe(
                map( User => {
                    return User;

                }),

                catchError(this.handleError)
            );
    }

    // getStores(id: number): Observable<IStore> {
    //     return this.http.get<IStore>(this.baseURL + '/' + id)
    //         .pipe(
    //             map(store => {
    //                 return store;
    //             }),
    //             catchError(this.handleError)
    //         );
    // }

    getStoresPage(page: number, pageSize: number): Observable<IPagedResults<IStore[]>> {
        return this.http.get<IPagedResult>(
            `${this.baseURL}/store/GetStores?page=${page}&pageSize=${pageSize}`,
            { observe: 'response' })
            .pipe(
                map(res => {
                    const pagedResult = res.body as IPagedResult;
                    return {
                        Results: pagedResult.List as IStore[],
                        TotalRecords: pagedResult.TotalRecords
                    };
                }),
                catchError(this.handleError)
            );
    }

    GetLocationList(): Observable<IStorageFacilityList[]> {
        return this.http.get<IStorageFacilityList[]>(
            `${this.baseURL}/store/GetLocationList` )
            .pipe(
                map(store => {
                    return store as IStorageFacilityList[];

                }),

                catchError(this.handleError)
            );
    }

    getPTIStores(): Observable<IPTIFacilityModel[]>{
        return this.http.get<IPTIFacilityModel[]>(
            `${this.baseURL}/store/GetPTIStores`)
            .pipe(
                map(res=>{
                    return res as IPTIFacilityModel[];
                }),
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.log('server error:', error);
        if (error.error instanceof Error) {
            const errMessage = error.error.message;
            this.appinsights.logEvent(errMessage);
            return throwError(errMessage);
        }
        return throwError(error || 'Node.js server error');
    }
}

